// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"AU3_thecomp__j7qP6"};